import React from "react"
import { ContentfulPage } from "#/features/contentful/contentful-page"
import { StaticAssetID } from "#/lib/contentful/contentfulClient"

export function MedicalPrimePage(): JSX.Element {
  return <ContentfulPage entryId={StaticAssetID.MEDICAL_PRIME_PAGE} flagEnabled={true} />
}
